import { useEffect, useState } from 'react';

export type DisplayMode = 'standard' | 'plant';

const STORAGE_KEY = 'expai_display_mode';
const CLASS_NAME = 'mode-plant';

function readMode(): DisplayMode {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw === 'plant' ? 'plant' : 'standard';
  } catch {
    return 'standard';
  }
}

export function useDisplayMode(): { mode: DisplayMode; setMode: (m: DisplayMode) => void } {
  const [mode, setModeState] = useState<DisplayMode>(() => readMode());

  useEffect(() => {
    const root = document.documentElement;
    if (mode === 'plant') {
      root.classList.add(CLASS_NAME);
    } else {
      root.classList.remove(CLASS_NAME);
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // ignore quota errors
    }
  }, [mode]);

  // Sync between tabs
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setModeState(e.newValue === 'plant' ? 'plant' : 'standard');
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return { mode, setMode: setModeState };
}
